import React from 'react';
import { SemanticICONS } from 'semantic-ui-react';
import { IconSizeProp } from 'semantic-ui-react/dist/commonjs/elements/Icon/Icon';
import { ATMIcon } from 'shared-it-appmod-ui';
import styles from './icon-text.module.scss';

type IProp = {
  text: string;
  icon?: SemanticICONS;
  size?: IconSizeProp;
};

const IconText: React.FC<IProp> = ({ text, icon, size }) => {
  return (
    <div className={styles.iconText}>
      <ATMIcon name={icon} size={size} />
      <p className={styles.iconP}>{text}</p>
    </div>
  );
};

export default IconText;
